export enum ACTIVITY_URL_PARAM_KEYS {
  ACTIVITY_ID = "activityId",
  FROM_DATE = "fromDate",
  UNTIL_DATE = "untilDate",
  ADULTS_COUNT = "adultsCount",
  STAR_RATING = "starRating",
  USER_RATING = "userRating",
  FREE_CANCELLATION = "freeCancellation",
  PRICE_RANGE_MIN = "priceMin",
  PRICE_RANGE_MAX = "priceMax",
  SORT_BY = "sortBy",
  // Note: CATEGORIES and POPULAR_FEATURE_TAGS excluded - they require API data to map
  RATING = "rating",
  DURATION = "duration",
  START_TIME = "startTime",
}
